<template>
  <div id="DoctorAtHand">
    <div class="container">
      <b-row class="topSection">
        <b-col class="col-md-6 col-12 p-5">
          <h3>Speak with a doctor, anytime, anywhere</h3>
          <p>
            AXA Doctor at Hand is a fast, easy and convenient way to speak to a
            GP or Advanced Nurse Practitioner by video or phone 365 days a year.
            GPs are available 24/7 and advanced Nurse Practitioners are
            available from 8am-10pm at a time and place that suits you.
          </p>
          <div>
            <ul>
              <li>Up to 20-minute appointments so there's no need to rush</li>
              <li>Get prescriptions delivered straight to your door</li>
              <li>Use alongside your NHS GP</li>
            </ul>
          </div>
        </b-col>
        <b-col class="col-md-6 col-12 p-5">
          <img
            src="https://media.spectrum.life/assets/axa/dca.png"
            alt="woman looking at phone"
            style="width: 100%; max-width: 450px"
            class="mx-auto d-block"
          />
          <div>
            <p class="px-5 pt-5 pb-2">
              Login using the code we sent you when you first registered for
              this service. If you've forgotten your code- don’t worry. Just ask
              reminder from AXA Doctor at Hand on the next screen.
            </p>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <b-button
              @click="openLinkDCA()"
              target="_blank"
              rel="noopner"
              class="btn py-4 px-5 btn-cta rounded-0"
            >
              Go to AXA Doctor at Hand
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
    <div class="pt-5 carousel-container">
      <HomeFilters
        title="Filters"
        :hardcoded-tags="['Life', 'Body', 'Exercise classes']"
      />
      <HomeCardCarousel
        title="Videos"
        class="car"
        type="standaloneArticles"
        additionalTag="Videos"
        :mute="true"
      >
      </HomeCardCarousel>
      <HomeCardCarousel
        title="Articles"
        class="car"
        cardType="article"
        type="standaloneArticles"
        additionalTag="Articles"
        :mute="true"
      >
      </HomeCardCarousel>
    </div>
  </div>
</template>

<script>
import HomeFilters from "@/components/Home/New/HomeFilters.vue";
import HomeCardCarousel from "@/components/Home/New/HomeCardCarousel.vue";

export default {
  name: "DoctorAtHand",
  components: { HomeCardCarousel, HomeFilters },
  data() {
    return {
      appleLink: "https://apps.apple.com/app/id1536116883",
      googleLink:
        "https://play.google.com/store/apps/details?id=com.axa.doctorathand"
    };
  },
  mounted() {},
  computed: {
    os() {
      return this.detectMobileOS();
    }
  },
  methods: {
    openLinkDCA() {
      window.open("https://doctorathand.app.link/oi8IFBAtoob", "_blank");
    }
  }
};
</script>

<style lang="less">
#DoctorAtHand {
  overflow-x: hidden;
  background-color: #fafafa !important;
  .topSection {
    h3 {
      font-weight: bold;
      font-size: 2.5em;
      margin-bottom: 40px;
    }
    .mainColumn {
      padding: 20px 5%;
    }
    p {
      font-size: 1.75em;
      margin-bottom: 40px;
    }
    li {
      font-size: 1.75em;
      margin-bottom: 10px;
    }
  }
}
</style>
